import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { EnquiryModal } from "@/components/EnquiryModal";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <EnquiryProvider>
            <SmoothScroll>
              <div className="noise-overlay" />
              <Navbar />
              <main className="relative z-10">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
              <FloatingWhatsApp />
              <EnquiryModal />
              <Toaster position="top-center" theme="dark" richColors />
            </SmoothScroll>
          </EnquiryProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
